import { matchesNestedKeyword } from '../../shared/utils/keyword-filter';
import { Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PageTitleService } from '../../core/services/page-title.service';
import { UserService } from '../../core/services/user.service';
import { PagerComponent } from '../../shared/components/pager.component';

const USER_ROLE_OPTIONS = [
  { id: 30, name: '店舗管理者' },
  { id: 20, name: 'FC管理者' },
  { id: 10, name: '本部管理者' },
  { id: 1, name: 'システム管理者' },
];

function roleName(role: number): string {
  if (role === 0) return '未設定';
  if (role === 1) return 'システム管理者';
  if (role === 10 || role === 11) return '本部管理者';
  if (role === 20 || role === 21) return 'FC管理者';
  if (role === 30 || role === 31) return '店舗管理者';
  return String(role);
}

@Component({
    selector: 'app-user-list',
    imports: [RouterLink, FormsModule, PagerComponent],
    template: `
<div class="animated fadeIn container-fluid">
  <div class="card">
    <div class="card-header">
      <span><i class="fa s-icon-list"></i> 一覧 <span>(全 {{filteredItems.length}} 件)</span></span>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12"><div style="height: 1px"></div></div>
      </div>
    </div>
    <div class="card-body">
      <div class="row" style="align-items: flex-end;">
        <div class="col-md-4">
          <div class="form-group">
            <label class="col-form-label" for="user_role">ログイン権限</label>
            <select class="form-control" id="user_role" name="user_role" [ngModel]="roleFilter" (ngModelChange)="roleFilter = $event; pageIndex = 0">
              <option [ngValue]="null">-- すべて --</option>
              @for (opt of roleOptions; track opt.id) {
                <option [ngValue]="opt">{{opt.name}}</option>
              }
            </select>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label class="col-form-label" for="keyword">キーワード検索</label>
            <input id="keyword" name="keyword" type="text" [ngModel]="keyword"
              (ngModelChange)="keyword = $event; pageIndex = 0"
              class="form-control" placeholder="ユーザー名、ログインIDなど">
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group row">
            <div class="col-md-12">
              <button class="btn btn-warning text-white" type="button" (click)="clearFilter()">
                <i class="fa s-icon-backspace fa-fw"></i>&nbsp;条件クリア
              </button>
            </div>
          </div>
        </div>
      </div>
      <hr>
    </div>
    <div class="card-body">
      <div class="form-group row">
        <div class="col-md-12">
          <a class="btn btn-primary text-white" routerLink="/user/new">
            <i class="fa s-icon-plus"></i>&nbsp;新規作成
          </a>
        </div>
      </div>
    </div>
    <div class="card-body">
          @if (!searching && filteredItems.length === 0) {
            <span>該当するデータはありません</span>
          }
          @if (filteredItems.length > 0) {
            <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>
            <table class="table table-bordered table-sm table-hover table-ptb-0">
              <thead>
                <tr>
                  <th style="width: 10%">状態</th>
                  <th>ユーザー名</th>
                  <th>ログインID</th>
                  <th>ログイン権限</th>
                  <th>所属</th>
                  <th style="width: 10%"></th>
                </tr>
              </thead>
              <tbody>
                @for (item of pagedItems; track item.id) {
                  <tr>
                    <td class="text-center">
                      @if (+item.status === 0) {
                        <button class="btn text-green p-0 bg-inherit active" type="button" (click)="setStatus(item, 1)">
                          <i class="fa fa-3x fa-toggle-on"></i>
                        </button>
                      }
                      @if (+item.status === 1) {
                        <button class="btn text-secondary bg-inherit p-0 active" type="button" (click)="setStatus(item, 0)">
                          <i class="fa fa-3x fa-toggle-off"></i>
                        </button>
                      }
                    </td>
                    <td>{{item.name}}</td>
                    <td>{{item.email}}</td>
                    <td>{{roleName(item.role)}}</td>
                    <td>{{item.owner?.name}}</td>
                    <td class="text-center">
                      <a class="mt-1 mb-1 btn btn-primary btn-sm text-white"
                        [routerLink]="['/user/edit', item.id]" title="編集">
                        <i class="fa s-icon-edit fa-fw"></i>
                      </a>
                      @if (+item.status === 0) {
                        <button class="mt-1 mb-1 btn btn-secondary btn-sm text-white" type="button" disabled title="削除">
                          <i class="fa s-icon-delete fa-fw"></i>
                        </button>
                      }
                      @if (+item.status === 1) {
                        <button class="mt-1 mb-1 btn btn-danger btn-sm" type="button" title="削除"
                          (click)="openDeleteModal(item)">
                          <i class="fa s-icon-delete fa-fw"></i>
                        </button>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
            <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>
      }
    </div>
  </div>
</div>

@if (showDeleteModal) {
  <div class="modal-backdrop fade show"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content border-danger">
        <div class="modal-header bg-danger">
          <h5 class="modal-title">ユーザーの削除</h5>
          <button type="button" class="close" (click)="showDeleteModal = false">
            <span class="text-white" aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="background-color: #FFF6F8 !important">
          <div class="form-group row">
            <label class="col-md-12 col-form-label">ユーザーを削除します。よろしいですか。</label>
          </div>
        </div>
        <div class="modal-footer" style="background-color: #FFF6F8 !important">
          <button class="btn bg-close text-white" type="button" (click)="showDeleteModal = false">
            <i class="fa s-icon-cancel fa-fw"></i>&nbsp;閉じる
          </button>
          <button class="btn btn-danger" type="button" (click)="deleteUser()">
            <i class="fa s-icon-delete"></i>&nbsp;削除
          </button>
        </div>
      </div>
    </div>
  </div>
}
  `
})
export class UserListComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private userService = inject(UserService);

  items: any[] = [];
  keyword = '';
  roleFilter: any = null;
  searching = true;
  showDeleteModal = false;
  selectedUser: any = null;
  readonly pageLimit = 100;
  pageIndex = 0;

  readonly roleOptions = USER_ROLE_OPTIONS;
  readonly roleName = roleName;

  get filteredItems(): any[] {
    let list = this.items.filter(item => matchesNestedKeyword(item, this.keyword));
    if (this.roleFilter != null) {
      list = list.filter(u => u.role === this.roleFilter.id || u.role === this.roleFilter.id + 1);
    }
    return list;
  }

  get pagedItems(): any[] {
    return this.filteredItems.slice(this.pageIndex * this.pageLimit, (this.pageIndex + 1) * this.pageLimit);
  }
  get totalPages(): number {
    return Math.ceil(this.filteredItems.length / this.pageLimit);
  }
  goToPage(p: number): void {
    this.pageIndex = Math.max(0, Math.min(p, this.totalPages - 1));
  }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('ユーザーマスター', 's-icon-list');
    try {
      this.items = await this.userService.list('all') ?? [];
    } finally {
      this.searching = false;
    }
  }

  async setStatus(item: any, status: number): Promise<void> {
    await this.userService.upsert({ id: item.id, status });
    item.status = status;
  }

  openDeleteModal(item: any): void {
    this.selectedUser = item;
    this.showDeleteModal = true;
  }

  deleteUser(): void {
    if (!this.selectedUser) return;
    this.userService.remove(this.selectedUser.id).then(() => {
      this.items = this.items.filter(u => u.id !== this.selectedUser.id);
      this.showDeleteModal = false;
    });
  }

  clearFilter(): void {
    this.keyword = '';
    this.roleFilter = null;
    this.pageIndex = 0;
  }
}
